import { render, staticRenderFns } from "./SHSideMenu.vue?vue&type=template&id=0cc6b55e&"
import script from "./SHSideMenu.vue?vue&type=script&lang=ts&"
export * from "./SHSideMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports